import '../badge/badge.jsx';
export const inferredObservability = true;
export default class Counter extends HTMLElement {
    static get observedAttributes() {
        return ['count'];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        function getValue(value) {
            return value.charAt(0) === '{' || value.charAt(0) === '[' ? JSON.parse(value) : !isNaN(value) ? parseInt(value, 10) : value === 'true' || value === 'false' ? value === 'true' ? true : false : value;
        }
        if (newValue !== oldValue) {
            switch (name) {
            case 'count':
                this.count = getValue(newValue);
                break;
            }
            this.render();
        }
    }
    constructor() {
        super();
        this.count = 0;
    }
    connectedCallback() {
        this.render();
    }
    render() {
        const {count} = this;
        this.innerHTML = `<div>
        <button onclick="this.parentElement.parentElement.count-=1; this.parentElement.parentElement.render();"> -</button>
        <span>You have clicked <wcc-badge counter="${ count }"></wcc-badge> times !!!</span>
        <button onclick="this.parentElement.parentElement.count+=1; this.parentElement.parentElement.render();"> +</button>
      </div>`;
    }
}
customElements.define('wcc-counter', Counter);